import Layout from "@/lib/Layout/Layout";
import { LeadsForm } from "@/sections/LeadsForm/LeadsForm";
import React from "react";
import Meta from "@/components/Meta";
import { footerData } from "./api/footerData";
import dynamic from "next/dynamic";
const LeadCaptureModal = dynamic(
  () => import("@/components/LeadCaptureForm/LeadCaptureModal")
);

const contact = () => {
  return (
    <Layout footerData={footerData}>
      <Meta
        title="Contact Us | Bonatra Healthcare Pvt. Limited"
        description="Connect with us at Bonatra Healthcare Pvt. Limited to get quality healthcare services. We provide personalized care, flexible payment options & 24/7 customer support"
      />
      {/* <LeadCaptureModal /> */}
      <LeadsForm />
    </Layout>
  );
};

export default contact;
